<template>
  <div>
    <el-row type="flex" justify="center">
      <el-col :span="6">
        <el-form ref="form" :model="account" label-width="120px">

          <h2 style="text-align: center;margin: 150px 0 50px 0">ログイン</h2>

          <el-form-item label="メールアドレス" prop="email">
            <el-input v-model.trim="account.email"></el-input>
          </el-form-item>

          <el-form-item label="パスワード" prop="password">
            <el-input v-model.trim="account.password" show-password></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit" style="width: 100px">ログイン</el-button>
            <el-button @click="onReturn" style="width: 100px">戻り</el-button>
          </el-form-item>

          <el-form-item>
            <a href="">メールアドレス・パスワードを忘れた場合（工事中）</a>
          </el-form-item>
        </el-form>

      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Login",
  methods: {
    onSubmit() {
      let account = this.account.email; // 输入登录的账号
      let password = this.account.password; //输入的密码

      //登录成功
      if (this.dbAccounts.indexOf(account) !== -1 && password === this.dbAccountPasswordMap.get(account)) {
        let dbId = this.dbDoctors.filter(d => d.email === account && d.password === password)[0].id;
        this.$router.push(`/doctor/${dbId}`);
        return
      }

      //账号不存在
      if (this.dbAccounts.indexOf(account) === -1) {
        this.$message({
          message: 'アカウントは存在しません',
          type: 'warning'
        });
        return;
      }

      //密码不正确
      if (password !== this.dbAccountPasswordMap.get(account)) {
        this.$message({
          message: 'パスワードは間違います',
          type: 'warning'
        });
      }

    },
    onReturn() {
      this.$router.push("/register")
    },
  },
  data() {
    return {
      account: {
        email: null,
        password: null
      },
      dbDoctors: null,
      dbAccounts: null,
      dbAccountPasswordMap: null
    }
  },
  created() {
    axios.get(`${this.GLOBAL.host}/rapha99Doctor/getAll`).then(resp => {
      this.dbDoctors = resp.data
      this.dbAccounts = resp.data.map(doctor => doctor.email)

      // 注意账号不能重复，否则会被覆盖
      let accountPasswordMap = new Map()
      resp.data.map(d => {
        accountPasswordMap.set(`${d.email}`, `${d.password}`)
      })
      this.dbAccountPasswordMap =accountPasswordMap
    })
  }
}
</script>

<style scoped>

</style>